<div class="notification">
  <p class="category-label">{{ 'TGA.Notifications.' + notification().type + '.Category' | translate }}</p>
  @if (notification().canBeClosed) {
    <mat-icon class="close" (click)="onClose()">close</mat-icon>
  }
  <div class="content">
    <div class="header">
      @if (
        notification().type === NotificationType.MissingNematodeAnalysis ||
        notification().type === NotificationType.MissingPcnAnalysis ||
        notification().type === NotificationType.MissingCropFieldData ||
        notification().type === NotificationType.PlantingDateNotAdjusted ||
        notification().type === NotificationType.EmergenceDateNotAdjusted ||
        notification().type === NotificationType.SupplementaryFertilizerAdvised ||
        notification().type === NotificationType.HeatstressDetectedForCustomer
      ) {
        @if (getNotificationCropFieldsLength(notification()) === 1) {
          <h3 class="title">
            {{ 'TGA.Notifications.' + notification().type + '.Title' | translate }}
            {{ getSingleCropFieldName(notification()) }}
          </h3>
        } @else {
          <h3 class="title">{{ 'TGA.Notifications.' + notification().type + '.TitlePlural' | translate }}</h3>
        }
        @if (
          notification().type !== NotificationType.MissingCropFieldData &&
          notification().type !== NotificationType.PlantingDateNotAdjusted &&
          notification().type !== NotificationType.EmergenceDateNotAdjusted &&
          notification().type !== NotificationType.SupplementaryFertilizerAdvised
        ) {
          @if (notification().type === NotificationType.HeatstressDetectedForCustomer) {
            <p class="subtitle">
              {{
                'TGA.Notifications.' + notification().type + '.Subtitle'
                  | translate
                    : {
                        fromDate: formatDate(asHeatstressDetectedForCustomer(notification()).fromDate),
                        toDate: formatDate(asHeatstressDetectedForCustomer(notification()).toDate),
                      }
              }}
            </p>
          } @else {
            <p class="subtitle">{{ 'TGA.Notifications.' + notification().type + '.Subtitle' | translate }}</p>
          }
        }
      } @else {
        <h3 class="title">{{ 'TGA.Notifications.' + notification().type + '.Title' | translate }}</h3>
      }
    </div>
    <div>
      @if (notification().type === NotificationType.QuestionnaireNotCompleted) {
        <app-questionnaire-not-completed-body [notification]="asQuestionnaireNotCompleted(notification())" />
      } @else if (notification().type === NotificationType.MissingCropFieldData) {
        <app-missing-cropfield-data-body [notification]="asMissingCropFieldData(notification())" />
      } @else if (notification().type === NotificationType.SupplementaryFertilizerAdvised) {
        <app-supplementary-fertilizer-advised-body [notification]="asSupplementaryFertilizerAdvised(notification())" />
      } @else if (notification().type === NotificationType.HeatstressDetectedForCustomer) {
        <app-heatstress-detected-for-customer-body [notification]="asHeatstressDetectedForCustomer(notification())" />
      } @else if (
        notification().type === NotificationType.MissingNematodeAnalysis ||
        notification().type === NotificationType.MissingPcnAnalysis ||
        notification().type === NotificationType.PlantingDateNotAdjusted ||
        notification().type === NotificationType.EmergenceDateNotAdjusted
      ) {
        <app-missing-or-incorrect-body [notification]="asMissingOrIncorrectData(notification())" />
      }
    </div>
    <button mat-stroked-button class="button" (click)="onAction()">
      {{ 'TGA.Notifications.' + notification().type + '.ActionText' | translate }}
    </button>
  </div>

  <!-- Decorative triangles -->
  <div class="triangle-decoration">
    <img src="assets/icons/triangle-decoration.svg" alt="" />
  </div>
</div>
